var path = 'src/app/forms/buttons.html';
var html = "<div class=form-group> <div ng-class=\"{'col-md-offset-3': horizontal, 'col-md-9': horizontal}\" ng-transclude></div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/forms/buttons.html
// module id = 296
// module chunks = 0